

module.exports.getConfig = function()
{
    return {
                environment: 'local',
                version: "40.20.4",
                apiServer: 'http://localhost:5191/api',

                cdnCloudUrl: 'https://res.cloudinary.com',
                cdnAppCloudName: 'rms-jinoby',
                cdnUsersCloudName: 'rms-uat-jinoby',

                dataDogClientToken: 'pubaf4145b736da8f2456f5b1c830be1538',
                dataDogSite: 'us3.datadoghq.com',

                messagingPlatformApiKey: "63n2Kw.dbighQ:1StjtuSiQmqy_RVxZWR4rYXGs2Nq3BWYQJml_sNwQok",
                googleMapsApiKey: 'AIzaSyDVCopNzpU1crTXtRTDtKkoOTZonDznLNY',

                shellApiServerPort: "6191",
                shellWebSocketServerPort: "6192",

                azureReferenceDataStorageAccountName: "devrmsreference",
                azureReferenceDataStorageAccountNameSaSToken: "?sv=2021-06-08&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2023-12-31T00:03:29Z&st=2022-11-24T16:03:29Z&spr=https&sig=0OgzKNV2ZZwucAeXjsB5BaGbci3buDO6Spsyw4z%2F3OQ%3D",

                appUrlWebOrdering: "http://localhost:3191",

                themeConfigUrl: "https://sarmsdevtheme.z35.web.core.windows.net",
                posThemeVersion: "40.0.0",

                beamerUrl: 'https://app.getbeamer.com/js/beamer-embed.js',
                beamerProductKey: 'XPvgBuMi58501',
                beamerEnabled: true,
           }
}







































